import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingApplyCTA from "@/components/FloatingApplyCTA";
import Landing from "@/pages/Landing";
import Onboard from "@/pages/Onboard";
import Success from "@/pages/Success";
import Guest from "@/pages/Guest";
import Investing from "@/pages/Investing";
import YourSasha from "@/pages/YourSasha";
import Portal from "@/pages/Portal";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSubmission from "@/pages/AdminSubmission";
import AdminSettings from "@/pages/AdminSettings";
import AdminScout from "@/pages/AdminScout";

function PublicChrome({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const isGuest = location.pathname.startsWith("/guest");
  const chromeless = isAdmin || isGuest;
  return (
    <>
      {!chromeless && <Header />}
      {children}
      {!chromeless && <FloatingApplyCTA />}
      {!chromeless && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App font-sans-body">
      <BrowserRouter>
        <PublicChrome>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/onboard" element={<Onboard />} />
            <Route path="/success" element={<Success />} />
            <Route path="/guest/:id" element={<Guest />} />
            <Route path="/investing" element={<Investing />} />
            <Route path="/your-sasha" element={<YourSasha />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="submissions/:id" element={<AdminSubmission />} />
              <Route path="scout" element={<AdminScout />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </PublicChrome>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#FAF9F6",
              color: "#2A1F1A",
              border: "1px solid #E3DED5",
              borderRadius: "2px",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
